module.exports = __webpack_public_path__ + "static/media/bg23.6457bb22.jpg";